<template lang="html">
    <div>
        <Drawer class="drawer-menu menu-bar-wrap" v-if="isMobile()" width="220" placement="left" :closable="false" v-model="showDrawerMenu">
            <Menu v-if="showMenu" :width="sidebarWidth+'px'" class="menu-bar" accordion :active-name="activeName" :open-names="openNames" @on-select="handleItemSelected">
                <template v-for="item in menu">
                    <Submenu v-if="item.subMenu && item.show" :key="item.name" :name="item.name">
                        <template slot="title">
                            <!-- <Icon :type="item.icon"></Icon> -->
                            <Icon class="c-icon" :custom="item.icon"></Icon>
                            {{item.title}}
                        </template>
                        <template v-for="subItem in item.subMenu">
                            <MenuItem v-if="subItem.show" :key="subItem.name" :name="subItem.name">{{subItem.title}}
                            </MenuItem>
                        </template>
                    </Submenu>
                    <MenuItem v-if="!item.subMenu && item.show" :key="item.name" :name="item.name">
                        <Icon class="c-icon" :custom="item.icon"></Icon>
                            {{item.title}}
                    </MenuItem> 
                </template>
            </Menu>
        </Drawer>
        <Sider v-if="!isFullscreen&&!isMobile()" class="side-bar menu-bar-wrap" :width="sidebarWidth" v-model="isCollapsed">
            <Menu v-if="showMenu" :width="sidebarWidth+'px'" class="menu-bar" accordion :active-name="activeName" :open-names="openNames" @on-select="handleItemSelected">
                <div :style="{'display':isCollapsed?'block':'none'}">
                    <template v-for="item in menu">
                        <Dropdown v-if="item.subMenu && item.show" :key="item.name" placement="right-start" transfer transfer-class-name="siderbar-dropdown" @on-click="handleItemSelected">
                            <MenuItem :name="item.name">
                                <!-- <Icon custom="c-icon c-icon-6"></Icon> -->
                                <Icon class="c-icon" :custom="item.icon"></Icon>
                            </MenuItem>
                            <DropdownMenu slot="list">
                                <template v-for="subItem in item.subMenu">
                                    <DropdownItem v-if="subItem.show" :key="subItem.name" :name="subItem.name" :selected="active==subItem.name?true:false">{{subItem.title}}</DropdownItem>
                                </template>
                            </DropdownMenu>
                        </Dropdown>
                        <Tooltip v-if="!item.subMenu && item.show" :key="item.name" :content="item.title" placement="right" transfer>
                            <MenuItem :name="item.name">
                                <Icon class="c-icon" :custom="item.icon"></Icon>
                            </MenuItem>
                        </Tooltip>
                    </template>
                </div>
                <div :style="{'display':!isCollapsed?'block':'none'}">
                    <template v-for="item in menu">
                        <Submenu v-if="item.subMenu && item.show" :key="item.name" :name="item.name">
                            <template slot="title">
                                <!-- <Icon :type="item.icon"></Icon> -->
                                <Icon class="c-icon" :custom="item.icon"></Icon>
                                {{item.title}}
                            </template>
                            <template v-for="subItem in item.subMenu">
                                <MenuItem v-if="subItem.show" :key="subItem.name" :name="subItem.name">{{subItem.title}}</MenuItem>
                            </template>
                        </Submenu>
                        <MenuItem v-if="!item.subMenu && item.show" :key="item.name" :name="item.name">
                            <Icon class="c-icon" :custom="item.icon"></Icon>
                                {{item.title}}
                        </MenuItem> 
                    </template>
                </div>
            </Menu>
        </Sider>
    </div>
</template>

<script>
// import constants from "../utils/constants";
// import request from "../utils/request";
import util from "../utils/util";

const links = {
    "0": "/",
    "1-1": "/item.html#/list",
    "2-1": "/platform.html#/list",
    "3-1": "/user.html#/list",
    "4-1": "/other.html#/support",
    "5-1": "/music.html#/list",
    "6-1": "/repurchase.html#/list",
};

export default {
    data() {
        return {
            menu: [
                {
                    name: "0",
                    title: "首页",
                    // icon: 'c-icon-24',
                    role: [1],
                },
                {
                    name: "1",
                    title: "商品管理",
                    // icon: 'c-icon-21',
                    subMenu: [
                        {
                            name: "1-1",
                            title: "商品列表",
                            role: [1],
                        }
                    ],
                },
                {
                    name: "2",
                    title: "小程序管理",
                    // icon: 'c-icon-19',
                    subMenu: [
                        {
                            name: "2-1",
                            title: "小程序列表",
                            role: [1],
                        },
                    ],
                },
                {
                    name: "6",
                    title: "复购管理",
                    // icon: 'c-icon-19',
                    subMenu: [
                        {
                            name: "6-1",
                            title: "复购列表",
                            role: [1],
                        },
                    ],
                },
                {
                    name: "3",
                    title: "用户管理",
                    // icon: 'c-icon-19',
                    subMenu: [
                        {
                            name: "3-1",
                            title: "用户列表",
                            role: [1],
                        },
                    ],
                },
                {
                    name: "5",
                    title: "音乐管理",
                    // icon: 'c-icon-19',
                    subMenu: [
                        {
                            name: "5-1",
                            title: "音乐列表",
                            role: [1],
                        },
                    ],
                },
                {
                    name: "4",
                    title: "其他设置",
                    // icon: 'c-icon-19',
                    subMenu: [
                        {
                            name: "4-1",
                            title: "技术支持",
                            role: [1],
                        },
                    ],
                },
            ],
            name: "",
            powerList: [],
            showMenu: false,
            isCollapsed: false,
            sidebarWidth: 220,
            collapsedActive: "",
            collapsedOpen: [],
            isFullscreen: false,
            showDrawerMenu: false,
            lastOrderId: ""
        };
    },
    computed: {
        activeName() {
            return this.isCollapsed ? this.collapsedActive : this.active;
        },
        openNames() {
            return this.isCollapsed ? this.collapsedOpen : this.open;
        },
    },
    props: {
        active: {
            type: String,
            default: "1",
        },
        open: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        active: {
            // handler(newValue, oldValue) {
            handler(newValue) {
                this.collapsedActive = newValue.split("-")[0];
            },
            deep: true,
        },
    },
    mounted() {
        let self = this;
        if (util.getUserName()) {
            self.isLogin = true;
            self.name = util.getUserName();
        }

        self._configMenu();

        // util.updateUserConfig().then(function () {
        //     self._configMenu();
        // });

        self.$nextTick(() => {
            self.collapsedActive = self.active.split("-")[0];
        });

        // self.isCollapsed = util.isMobile();
        // self.sidebarWidth = self.isCollapsed ? 80 : 220;

        self.$root.$on("Sidebar_Collapsed", function (isCollapsed) {
            self.isCollapsed = isCollapsed;
            self.sidebarWidth = isCollapsed ? 80 : 220;
        });

        self.$root.$on("Sidebar_Show", function (show) {
            self.showDrawerMenu = show;
        });

        [
            "fullscreenchange",
            "webkitfullscreenchange",
            "mozfullscreenchange",
        ].forEach((item) => {
            document.addEventListener(item, () => {
                let isFullScreen =
                    document.fullScreen ||
                    document.mozFullScreen ||
                    document.webkitIsFullScreen ||
                    document.fullscreenElement;
                self.isFullscreen = isFullScreen;
            });
        });

    },
    methods: {
        handleItemSelected(name) {
            let self = this;
            if (links[name]) {
                window.location.href = links[name];
            }
            self.showDrawerMenu = false;
        },
        isMobile() {
            return util.isMobile();
        },
        // _hasPower(myPowers, menuPowers) {
        //     if (menuPowers && menuPowers[0] === 0) {
        //         return true;
        //     }
        //     let intersect = myPowers.filter(function (v) {
        //         return menuPowers.indexOf(v) !== -1;
        //     });

        //     return intersect.length > 0;
        // },
        _configMenu() {
            let self = this;
            let userInfo = util.getLoginUserInfo();
            let userId = userInfo.userId;
            // console.log("111111 ~ file: NavigationBar.vue:282 ~ _configMenu ~ userId:", userId);
            // let powerList = userConfig.powerList;
            // let role = userConfig.platformType;
            // let powers = [];
            // let baseRegion = util.getUserConfig()['baseRegion'];

            // powerList &&
            //     powerList.forEach((item) => {
            //         powers.push(item.power);
            //     });

            self.menu.forEach((menu) => {
                if (menu.subMenu) {
                    let showCount = 0;
                    menu.subMenu.forEach((subMenu) => {
                        // let hasPower = true;
                        let isRole = false;

                        // hasPower = self._hasPower(powers, subMenu.power);
                        if (subMenu.role) {
                            isRole = subMenu.role.includes(userId);
                        }
                       
                        // subMenu.show = hasPower || isRole;
                        subMenu.show = isRole;
                        if (subMenu.show) {
                            showCount++;
                        }
                    });

                    menu.show = 0 !== showCount;
                } else {
                    // let hasPower = true;
                    let isRole = false;
                    
                    // hasPower = self._hasPower(powers, menu.power);
                    if (menu.role) {
                        isRole = menu.role.includes(userId);
                    }

                    // menu.show = hasPower || isRole;
                    menu.show = isRole;
                }
            });

            self.showMenu = true;
        },
    },
};
</script>

<style>
.side-bar {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    padding-top: 64px;
    background-color: #191a23 !important;
}

.menu-bar.ivu-menu-vertical.ivu-menu-light:after {
    display: none;
}

.menu-bar .ivu-menu-item {
    transition: none !important;
}

.menu-bar .ivu-menu-submenu .ivu-menu-item {
    padding-left: 28px !important;
    background-color: #101117 !important;
}

.menu-bar .ivu-menu-item-active {
    background-color: #191a23 !important;
}

.menu-bar .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #ffffff !important;
    background-color: #101117 !important;
}

.menu-bar .ivu-menu-submenu .ivu-menu-item.ivu-menu-item-selected {
    color: #ffffff !important;
    background-color: #2d8df0 !important;
}

.menu-bar .ivu-menu-item-selected::after {
    display: none !important;
}

.menu-bar .ivu-menu-item,
.menu-bar .ivu-menu-submenu-title {
    color: rgba(255, 255, 255, 0.7);
    white-space: nowrap;
    overflow: hidden;
    display: flex;
    align-items: center;
    line-height: 14px;
    height: 52px;
}

.menu-bar .ivu-menu-item:hover,
.menu-bar .ivu-menu-submenu-title:hover {
    color: #ffffff !important;
}

.menu-bar .ivu-menu-child-item-active .ivu-menu-submenu-title {
    color: #ffffff !important;
}
/* .side-bar .ivu-menu-child-item-active .ivu-menu-submenu-title::before {
    content: '';
    display: block;
    width: 4px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #2d8cf0;
} */

.menu-bar-wrap .menu-bar {
    position: fixed;
    /* min-height: 100vh; */
    /* width: 220px !important; */
    background-color: #191a23;
    transition: all 0.2s ease-in-out;
    height: calc(100vh - 64px);
    overflow-y: auto;
}
.drawer-menu.menu-bar-wrap .menu-bar {
    height: 100vh;
}
.menu-bar-wrap .menu-bar::-webkit-scrollbar {
    width: 0;
}
.menu-bar-wrap .menu-bar::-webkit-scrollbar-track {
    background-color: transparent;
}
.menu-bar-wrap .menu-bar::-webkit-scrollbar {
    width: 0;
}

.side-bar .sider-trigger {
    height: 32px;
    margin: 10px 0;
    background-color: #4071ff;
    color: #ffffff;
    display: flex;
    align-items: center;
    padding-left: 22px;
    white-space: nowrap;
    overflow: hidden;
}

.side-bar .sider-trigger-collapsed {
    padding-left: 0;
    justify-content: center;
    font-size: 16px;
}

.side-bar.ivu-layout-sider-collapsed .ivu-menu-item {
    justify-content: center;
    font-size: 16px;
    line-height: 16px;
}

.side-bar.ivu-layout-sider-collapsed .ivu-menu-item > i {
    margin-right: 0;
}

.menu-bar-wrap .menu-bar .ivu-dropdown,
.menu-bar-wrap .menu-bar .ivu-tooltip,
.menu-bar-wrap .menu-bar .ivu-tooltip .ivu-tooltip-rel {
    display: block;
}

.siderbar-dropdown.ivu-select-dropdown {
    margin-left: 5px;
    background-color: #191a23;
}

.siderbar-dropdown .ivu-dropdown-menu {
    min-width: 160px;
}

.siderbar-dropdown .ivu-dropdown-item {
    color: rgba(255, 255, 255, 0.7);
    background-color: #191a23;
    padding: 12px 16px;
    font-size: 14px !important;
}

.siderbar-dropdown .ivu-dropdown-item:hover {
    color: #ffffff;
    background-color: #191a23;
}

.siderbar-dropdown .ivu-dropdown-item-selected,
.siderbar-dropdown .ivu-dropdown-item-selected:hover {
    background-color: #2d8df0 !important;
    color: #ffffff;
}

.drawer-menu .ivu-drawer-body {
    padding: 0 !important;
}
</style>
